import { useT } from "../i18n/hooks.ts";
import { MapSettingsIcon } from "./MapSettingsIcon.tsx";
import { DropdownMenu } from "./DropdownMenu.tsx";

export function MapSettingsMenu({
  showOverview,
  onToggleOverview,
  showLinkDirection,
  onToggleShowLinkDirection,
  open,
  onToggle,
  onClose,
}: {
  showOverview: boolean;
  onToggleOverview: () => void;
  showLinkDirection: boolean;
  onToggleShowLinkDirection: () => void;
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
}) {
  const t = useT();

  return (
    <DropdownMenu
      open={open}
      onToggle={onToggle}
      onClose={onClose}
      triggerClassName="button-icon topbar-icon-button dropdown-trigger"
      triggerLabel={t("mapSettings.title")}
      triggerIcon={<MapSettingsIcon />}
      closeOnLeave={false}
    >
      <label className="settings-row">
        <span className="settings-row-label">{t("networkMap.toggleOverview")}</span>
        <input type="checkbox" checked={showOverview} onChange={onToggleOverview} />
      </label>
      <label className="settings-row">
        <span className="settings-row-label">{t("map.showLinkDirection")}</span>
        <input type="checkbox" checked={showLinkDirection} onChange={onToggleShowLinkDirection} />
      </label>
    </DropdownMenu>
  );
}
